import AddRemoveToFavBtn from './AddRemoveToFavBtn';

export default AddRemoveToFavBtn;
